import React from 'react';
import Footer from '../../components/Footer';
import HousekeepingImg from "../../assets/images/diplomao.jpeg";
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Title from '../../components/TitleComponent';

const DiplomaHousekeeping = () => {
  return (
    <div className='w-full relative font-poppins bg-gray-50'>
      <Title canonicalPath="/programmes/diploma-courses/diploma-in-pharmacy" />
      <Title title="Diploma in Housekeeping at Maya Devi University, Dehradun" description="Enroll in the Diploma in Housekeeping program at MDU, Dehradun. Gain essential skills for a successful career in hospitality and facility management." />
      <div className='w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5'>
        {/* Hero Section with Modern Styling */}
        <div className='text-center mb-10'>
          <h2 className='mb-4 text-2xl md:text-6xl tracking-tight font-bold text-[#0e4d38] 
            bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-transparent bg-clip-text'>
            Diploma in Housekeeping
          </h2>
          <div className='w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] rounded-full'></div>
        </div>

        {/* Main Content with Card-like Design */}
        <div className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between 
          bg-white shadow-lg rounded-xl p-6 md:p-10'>
          <img 
            src={HousekeepingImg} 
            className='md:w-[40%] rounded-lg object-cover shadow-md transition-transform duration-300 hover:scale-105' 
            alt="Diploma in Housekeeping" 
          />
          <div className='flex flex-col gap-4'>
            <h4 className='font-bold text-xl md:text-3xl text-[#0e4d38]'>About the Department</h4>
            <p className='text-justify md:text-lg text-gray-700 leading-relaxed'>
              The Diploma in Housekeeping is a comprehensive 1 ½ year program designed to provide students with essential skills and knowledge for a successful career in the hospitality and housekeeping sectors. This program blends theoretical and practical training to ensure students are well-prepared for roles in hotels, resorts, cruise lines, and other hospitality venues. Graduates of this program will excel in maintaining high standards of cleanliness, organization, and guest satisfaction, paving the way for a rewarding career in the hospitality industry.
            </p>
            <Link to="https://admission.maya.edu.in/" className='self-start'>
              <button 
                className='mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold 
                transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2 group'
              >
                Register Now
                <ArrowRight className='group-hover:translate-x-1 transition-transform' size={20} />
              </button>
            </Link>
          </div>
        </div>

        {/* Tables with Modern Styling */}
        <div className="space-y-8">
          {/* Course Details Table */}
          <div className="bg-white shadow-md rounded-xl overflow-x-auto">
            <table className="min-w-full text-center text-sm font-light">
              <thead className="bg-[#23376c] text-white">
                <tr>
                  <th className="px-6 py-4">Programme</th>
                  <th className="px-6 py-4">Branch/ Specialization</th>
                  <th className="px-6 py-4">Duration (Years)</th>
                  <th className="px-6 py-4">No. of Seats</th>
                  {/* <th className="px-6 py-4">One time Charges</th>
                  <th className="px-6 py-4">Yearly Fee (All India Quota)</th>
                  <th className="px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="whitespace-nowrap px-6 py-4 font-semibold">Diploma in Hotel Management (DHM)</td>
                  <td className="whitespace-nowrap px-6 py-4">Housekeeping</td>
                  <td className="whitespace-nowrap px-6 py-4">1+1</td>
                  <td className="whitespace-nowrap px-6 py-4">20</td>
                  {/* <td className="whitespace-nowrap px-6 py-4">Rs.11000/-</td>
                  <td className="whitespace-nowrap px-6 py-4">Rs.60000/-</td>
                  <td className="whitespace-nowrap px-6 py-4">Rs.45000/-</td> */}
                </tr>
              </tbody>
            </table>
          </div>

          {/* Hostel Fee Table */}
          {/* <div className="bg-white shadow-md rounded-xl overflow-x-auto">
            <table className="min-w-full text-center text-sm font-light">
              <thead className="bg-[#23376c] text-white">
                <tr>
                  <th colSpan="3" className="px-6 py-4">Hostel Fee</th>
                </tr>
                <tr>
                  <th className="px-6 py-4">Sr. No</th>
                  <th className="px-6 py-4">Type</th>
                  <th className="px-6 py-4">Fee</th>
                </tr>
              </thead>
              <tbody>
                {[ 
                  {no: 1, type: 'Triple Sharing (Non AC)', fee: '75000/-'},
                  {no: 2, type: 'Double Sharing (Non Ac)', fee: '85000/-'},
                  {no: 3, type: 'Triple Sharing (AC)', fee: '115000/-'},
                  {no: 4, type: 'Double Sharing (Ac)', fee: '125000/-'}
                ].map((item) => (
                  <tr key={item.no} className="border-b">
                    <td className="whitespace-nowrap px-6 py-4">{item.no}</td>
                    <td className="whitespace-nowrap px-6 py-4">{item.type}</td>
                    <td className="whitespace-nowrap px-6 py-4">{item.fee}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div> */}
        </div>

        {/* Additional Sections with Modern Card Design */}
        <div className='space-y-8 mt-10 mb-[100px]'>
          {[ 
            {
              title: 'Eligibility Criteria',
              content: '10+2 (In any Stream)'
            },
            {
              title: 'Career Prospects of the Course',
              content: [
                'Opportunities in renowned hotels and resorts.',
                'Roles in cruise lines and luxury hospitality.',
                'Event planning and management companies.',
                'Self-employment through entrepreneurship in housekeeping services.'
              ]
            },
            {
              title: 'Career Options',
              content: [
                'Housekeeping Manager',
                'Room Attendant',
                'Guest Service Supervisor',
                'Executive Housekeeper',
                'Laundry Manager'
              ]
            }
          ].map((section, index) => (
            <div 
              key={index} 
              className='bg-white shadow-md rounded-xl p-6 hover:shadow-lg transition-shadow'
            >
              <h4 className='text-2xl font-semibold text-[#0e4d38] mb-4'>{section.title}</h4>
              {Array.isArray(section.content) ? (
                <ul className='list-disc pl-5 space-y-2'>
                  {section.content.map((item, i) => (
                    <li key={i} className='text-gray-700'>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className='text-gray-700'>{section.content}</p>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default DiplomaHousekeeping;
